import Former from "../classes/Former";
import {hideElement, showElement} from "../utils";

class NewsBlock extends Former {

    blockHideableElementSelector = '.news-item';

    elementDataSearchableTypes = {
        type: 'news',
    }

    blockModifiers = {
        expanded: 'block-news--expanded',
        filtered: 'block-news--filtered'
    }

    allNews: { element: HTMLElement, date: Date }[] = []

    constructor(elementRoot: HTMLDivElement) {
        super(elementRoot);

        if (this.blockElementRoot) {
            this.allNews = [...document.querySelectorAll(this.blockHideableElementSelector)].map((newsItem: HTMLElement) => {
                const newsUpdateDate = new Date(newsItem.dataset.newsUpdated);

                return {
                    element: newsItem,
                    date: newsItem.dataset?.newsUpdated ? new Date(newsUpdateDate.getFullYear(), newsUpdateDate.getMonth()) : null
                }
            });
        }

    }

    processForm(event: SubmitEvent): any {
        const parentProcess = super.processForm(event);


        /**
         * --- DataSet on newsitem ---
         * dateFrom
         * dateTo
         * category
         */

        /**
         * Convert date or month to 00:00 (since JS defaults to 02:00 for some reason in Swedish timezone)
         */
        const dateFrom = parentProcess.formDataObject['date-from'] ? new Date(`${parentProcess.formDataObject['date-from']}T00:00`) : null;
        const dateTo = parentProcess.formDataObject['date-to'] ? new Date(`${parentProcess.formDataObject['date-to']}T00:00`) : null;
        let hasBeenFiltered = false;

        this.allNews.forEach((item) => {

            /**
             * If not in the date interval
             */
            if (!this.isDateInBetweenDates(item.date, dateFrom, dateTo)) {
                hideElement(item.element);
                hasBeenFiltered = true;
                return;
            }

            /**
             * If not the wanted category
             */
            if (parentProcess.formDataObject?.category) {
                if (item.element.dataset?.newsCategoryType !== parentProcess.formDataObject?.category) {
                    hideElement(item.element);
                    hasBeenFiltered = true;
                    return;
                }
            }

            showElement(item.element)
        })

        if (hasBeenFiltered || dateFrom || dateTo) {
            this.blockElementRoot.classList.add(this.blockModifiers.filtered)
        } else {
            this.blockElementRoot.classList.remove(this.blockModifiers.filtered)
        }

    }

    /**
     * Check if a date is between from and to
     * Takes date, from and to is optional.
     *
     * When no from date is provided, it will default to 1 jan 1970
     * When no to date is provided it will default to today (now)
     */
    isDateInBetweenDates(date: Date, from?: Date, to?: Date) {
        return date >= (from || new Date(0)) && date <= (to || new Date());
    }
}

export default NewsBlock;